import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Navbar extends Component {
	
    render() {
        let publicUrl = process.env.PUBLIC_URL+'/'
        let imgattr = 'logo'
        let anchor = '#'
        return (
           <header className="site-header-one go-top">
			  <nav className="main-nav__one stricky">
			    <div className="container-fluid">
			      <div className="main-nav__logo-box">
			        <Link to="/">
			          <img src={publicUrl+"assets/images/logo-full-light.png" } alt={ imgattr } />
			        </Link>
			        <a href="#" className="side-menu__toggler"><i className="fa fa-bars" /></a>
			      </div>{/* /.main-nav__logo-box */}
				  <div className="main-nav__main-navigation">
				  <ul className=" main-nav__navigation-box">
			          <li>
			            <Link to="/home-v4">Home</Link>
			          </li>
			          <li className="dropdown">
					  <Link to="#">Services</Link> 
			            <ul>
			              <li><Link to="/service">Lead Genration</Link></li>
			              <li><Link to="/PaidAdvertisement">Paid Advertisement</Link></li>
			              <li><Link to="/SocialMediaMarketing">Social Media Marketing</Link></li>
			              <li><Link to="/EmailMarketing">Email Marketing</Link></li>
			              <li><Link to="/ContentMarketing">Content Marketing</Link></li>
			              <li><Link to="/WebsiteDesignandDevelopment">Website Design and Development</Link></li>
			              <li><Link to="/SEO">Search Engine Optimization</Link></li>
			              <li><Link to="/service-details">Services Details</Link></li>
			            </ul>{/* /.sub-menu */}
			          </li>
			          <li className="dropdown">
					  	<Link to="#">PortFolio</Link> 
			            <ul>
			              <li><Link to="/portfolio-standard">Portfolio Standard</Link></li>
			              <li><Link to="/portfolio-full">Portfolio Full</Link></li>
			              <li><Link to="/portfolio-masonary">Portfolio Masonary</Link></li>
			              <li><Link to="/portfolio-details">Portfolio Details</Link></li>
			            </ul>
						{/* /.sub-menu */}
			          </li>
			          <li className="dropdown">
			            <Link to="#">Blogs</Link>
			            <ul>
			              <li><Link to="/blog-grid">Blogs Page</Link></li>
			              <li><Link to="/blog-list">Blogs List</Link></li>
			              <li><Link to="/blog-details">Blogs Details</Link></li>
			            </ul>{/* /.sub-menu */}
			          </li>
			          <li>
			            <Link to="#">Who We Serve</Link> 
			            {/* <ul>
			              <li><Link to="/pricing">Pricing</Link></li>
			              <li><Link to="/faq">FAQ</Link></li>
			              <li><Link to="/testimonial">Testimonials</Link></li>
			              <li><Link to="/team">Team</Link></li>
			            </ul> */}
						{/* /.sub-menu */}
			          </li>
			          <li>
			            <Link to="#">Schedule Free Consultation</Link>
			          </li>
					  <li>
			            <Link to="/contact">Contact</Link>
			          </li>
			        </ul>
			      </div>{/* /.main-nav__main-navigation */}
			      <div className="main-nav__right">
			        <Link to="/contact" className="thm-btn">Free Trial <i className="fa fa-angle-right" /></Link>
			        {/* /.thm-btn */}
			      </div>{/* /.main-nav__right */}
			    </div>
			  </nav>
			</header>
        )
    }
}


export default Navbar